const checkGtinType = (gtin) => {
  if (gtin.toLowerCase().startsWith("w")) {
    const newGtin = gtin.substring(1, 7);
    const quantity = gtin.substring(7);
    return { newGtin, quantity };
  } else {
    return { newGtin: gtin };
  }
};

const checkUnitType = (quantity, uom) => {
  const unit = ["kg", "kgs", "kilograms", "ltr", "ltrs", "litres", "litre"];
  if (unit.some((u) => uom.includes(u))) {
    return quantity / 1000;
  }
  return quantity;
};

const sortItems = (arr) => arr.sort((a, b) => b?.modifiedDate.localeCompare(a?.modifiedDate));

const limitWords = (str, limit) => {
  if (!str) return "";
  const words = str.split(" ");
  const limitedWords = words.slice(0, limit);
  return limitedWords.join(" ");
};

// Rounds a payable amount using the configured roundOffFloor threshold.
// The fractional part is dropped up to and including the threshold and rounded
// up beyond it, e.g. with a threshold of 0.7: 73.7 -> 73 and 73.8 -> 74.
// Without a configured threshold we fall back to the usual half-up rounding.
const applyRoundOff = (amount, roundOffFloor) => {
  if (amount === undefined || amount === null || amount === "") return amount;

  const numericAmount = Number(amount);
  if (!Number.isFinite(numericAmount)) return amount;

  const threshold = Number(roundOffFloor);
  if (!Number.isFinite(threshold) || threshold <= 0 || threshold >= 1) {
    return Math.round(numericAmount);
  }

  const sign = numericAmount < 0 ? -1 : 1;
  const absoluteAmount = Math.abs(numericAmount);
  const wholePart = Math.floor(absoluteAmount);
  // Guard against binary float noise (e.g. 73.7 - 73 = 0.7000000000000028)
  const fraction = Number((absoluteAmount - wholePart).toFixed(4));

  return sign * (fraction <= threshold ? wholePart : wholePart + 1);
};

export { checkGtinType, checkUnitType, sortItems, limitWords, applyRoundOff };
